import type { BracketMatchDto, TournamentDto } from '@penalty-cup/shared';
import { roundTitle } from '../strings.js';

/** Сетка турнира: колонки 1/4 → 1/2 → финал; свои матчи подсвечены. */
export function Bracket({ tournament }: { tournament: TournamentDto }) {
  const byId = new Map(tournament.players.map((p) => [p.id, p]));
  const rounds = [...new Set(tournament.matches.map((m) => m.round))].sort();

  const line = (m: BracketMatchDto, side: 'A' | 'B') => {
    const id = side === 'A' ? m.playerAId : m.playerBId;
    const p = id ? byId.get(id) : null;
    const score = side === 'A' ? m.scoreA : m.scoreB;
    const won = m.winnerId && m.winnerId === id;
    const lost = m.winnerId && id && m.winnerId !== id;
    return (
      <div
        className={`bracket__player ${p?.isYou ? 'bracket__player--you' : ''} ${won ? 'bracket__player--won' : ''} ${lost ? 'bracket__player--lost' : ''}`}
      >
        <span className="bracket__name">{p ? p.name : '—'}</span>
        <span className="bracket__score">{m.status === 'PENDING' ? '' : score}</span>
      </div>
    );
  };

  return (
    <div className="bracket">
      {rounds.map((r) => (
        <section key={r} className="bracket__round">
          <h3 className="bracket__title">{roundTitle(r, tournament.size)}</h3>
          {tournament.matches
            .filter((m) => m.round === r)
            .map((m) => {
              const mine = [m.playerAId, m.playerBId].includes(tournament.youId);
              return (
                <div
                  key={m.id}
                  className={`bracket__match ${mine ? 'bracket__match--mine' : ''} bracket__match--${m.status.toLowerCase()}`}
                >
                  {line(m, 'A')}
                  {line(m, 'B')}
                  {m.status === 'ACTIVE' && <span className="bracket__live">идёт</span>}
                </div>
              );
            })}
        </section>
      ))}
    </div>
  );
}
